export default __webpack_public_path__ + "static/media/02.2effab26.gif";